<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Usuários</li>
        </ol>

        <div class="row">
          <div class="col-md-12 ">
            <div class="pull-right">
              <router-link to="usuarios/criar-usuario"  class="btn_1 medium mb-3">Criar novo Usuário</router-link>
            </div>
          </div>
        </div>

        <v-card>
          <v-card-title>
            <h3>Usuários</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :headers="headers" :items="usuarios" :search="search" :pagination.sync="pagination" class="less-space">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.created_at)}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.role }}</td>
              <td>{{ props.item.master }}</td>
              <td class="text-xs-right many-buttons">
                <span class="text-xs-right many-buttons" v-if="!(props.item.deleted_at)">
                  <router-link
                    class="btn mr-2 text-white blue-grey darken-4"
                    :to="'usuarios/'+props.item.id"
                  >
                    <i class="fa fa-eye"></i> Detalhes
                  </router-link>
                  <button class="btn btn-danger text-center" @click="desativaUser(props.item)">
                    <i class="fa fa-times"></i> Desativar
                  </button>
                </span>
                <span class="text-xs-right many-buttons" v-else>
                  <button class="btn btn-info text-center text-white" @click="ativaUser(props.item)">
                    <i class="fa fa-check"></i> Ativar
                  </button>
                </span>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, confirmaSoft } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      headers: [
        { text: "Data de criação", value: "created_at" },
        { text: "Nome", value: "name" },
        { text: "E-Mail", value: "email"},
        { text: "Tipo", value: "role"},
        { text: "Usuário Principal", value: "master"},
        { text: "", value: ""}
      ],
      tipos: [
        { tipo:'Master', id: 1},
        { tipo:'Empresa', id: 2}
      ],
      usuarios: [],
      isLoading: false
    };
  },
  mounted() {
    var self = this;

    self.isLoading = true;
    ajax("get", "users")
      .then(res => {
        self.isLoading = false;
        self.usuarios = res;

        self.usuarios.forEach(item => {
          let temp = self.tipos.find(s => s.id === item.role)
          item.role = temp.tipo
        })
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error);
      });
  },
  methods: {
    async desativaUser(user){
      if(await confirmaSoft()) {
        let self = this;
        self.isLoading = true;
        ajax("delete", "users/" + user.id)
          .then(() => {
            let indexItemRemovido = self.usuarios.findIndex(
              x => x.id == user.id
            );
            self.usuarios[indexItemRemovido].deleted_at = 1;
            self.isLoading = false;
            alerta(
              "success",
              "Desativado",
              "Usuário desativado com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
    },
    ativaUser(user){
      let self = this;
      self.isLoading = true;
      ajax("put", "users/" + user.id, {deleted_at: null})
      .then(() => {
        self.isLoading = false;
        let indexItemRemovido = self.usuarios.findIndex(
            x => x.id == user.id
        );
        self.usuarios[indexItemRemovido].deleted_at = null;
        alerta(
          "success",
          "Ativada",
          "Usuário ativado com sucesso!"
        );
      })
      .catch(err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      })
    }
  }
};
</script>